export default __webpack_public_path__ + "media/Dairy-Cream.08a4a547.png";